import moment from 'moment'
const { fetcher } = require('services/helpers/responseHandler')

const getMessages = async kind => fetcher.get(`content/campaign/custom/list?kind=${kind}`)

const sendTestMessage = async ({
  audience,
  sendExactlyOn = null,
  messageTemplate,
  mediaUrls = [],
  promotionCode,
  minNightsToStay,
  promotionTagline,
  maxDiscountPercentage,
  promoValidityStartDate,
  promoValidityEndDate,
  hasPromoValidityDate
}) =>
  fetcher.post(`content/announcement/test`, {
    kind: audience,
    sendExactlyOn,
    details: {
      messageTemplate,
      deliveryName: `${audience} - ${moment(sendExactlyOn).format('MMM DD, YYYY')}`,
      messageMediaUrls: mediaUrls,
      promotionCode,
      minNightsToStay,
      promotionTagline,
      maxDiscountPercentage,
      promoValidityStartDate,
      promoValidityEndDate,
      hasPromoValidityDate
    }
  })

const add = async ({
  audience,
  startDate = null,
  endDate = null,
  messageTemplate,
  mediaUrls = [],
  promotionCode,
  minNightsToStay,
  promotionTagline,
  maxDiscountPercentage,
  promoValidityStartDate,
  promoValidityEndDate,
  hasPromoValidityDate,
  isRepeat = false,
  repeatKind = null,
  daysOfWeeks = [],
  sendExactlyOn
}) =>
  fetcher.post(`content/campaign/announcement/add`, {
    kind: audience,
    startDate,
    endDate,
    sendExactlyOn,
    details: {
      messageTemplate,
      messageMediaUrls: mediaUrls,
      promotionCode,
      minNightsToStay,
      promotionTagline,
      maxDiscountPercentage,
      promoValidityStartDate,
      promoValidityEndDate,
      hasPromoValidityDate
    },
    isRepeat,
    repeatKind: repeatKind || 'None',
    daysOfWeeks
  })

const addRecurring = async ({
  audience,
  sendExactlyOn = null,
  messageTemplate,
  mediaUrls = [],
  repeatCount
}) => {
  const promisesArray = Array(repeatCount)
    .fill(null)
    .map((_, i) =>
      add({
        audience,
        sendExactlyOn: moment(sendExactlyOn).add(i, 'weeks').format('YYYY-MM-DD h:mm A'),
        messageTemplate,
        mediaUrls
      })
    )

  return Promise.all(promisesArray)
}

const update = async ({
  recurringAnnouncementId,
  startDate,
  endDate,
  messageTemplate,
  mediaUrls = [],
  isRepeat,
  repeatKind,
  daysOfWeeks
}) =>
  fetcher.put(`content/campaign/announcement/recurring`, {
    recurringAnnouncementId,
    startDate,
    endDate,
    details: {
      messageTemplate,
      messageMediaUrls: mediaUrls,
      customDeliveryStatus: 'Approved',
      deliveryStartDate: startDate,
      deliveryFinishDate: endDate
    },
    isRepeat,
    repeatKind,
    daysOfWeeks
  })

const getAudiences = async () => fetcher.get('audiences/inhouse')

const getEligibilityReasons = async ({ audience }) =>
  fetcher.get('audiences/inhouse/eligibility-reasons', { category: audience })

const getDefaultText = async ({ audience }) =>
  fetcher.get('content/announcements/defaultTextContent', { kind: audience })

const getRecurringAnnouncement = async id =>
  fetcher.get(`content/campaign/announcement/recurring?recurringAnnouncementId=${id}`)

const enableRecurringAnnouncement = async id =>
  fetcher.post(`content/campaign/announcement/recurring/enable`, {
    recurringAnnouncementId: id
  })

const disableRecurringAnnouncement = async id =>
  fetcher.post(`content/campaign/announcement/recurring/disable`, {
    recurringAnnouncementId: id
  })

const cancelRecurringAnnouncement = async id =>
  fetcher.post(`content/campaign/announcement/recurring/cancel`, {
    recurringAnnouncementId: id
  })

const announcementApi = {
  getMessages,
  getAudiences,
  getEligibilityReasons,
  add,
  update,
  addRecurring,
  getDefaultText,
  sendTestMessage,
  getRecurringAnnouncement,
  enableRecurringAnnouncement,
  disableRecurringAnnouncement,
  cancelRecurringAnnouncement
}

export default announcementApi
